import { c as _c } from "react/compiler-runtime";
import { TOP_BAR_HEIGHT } from '@shared/theme';
import { useRouter } from 'next/navigation';
export const useHash = () => {
  const $ = _c(2);
  const router = useRouter();
  let t0;
  if ($[0] !== router) {
    const scrollToSection = (id, t1, t2) => {
      const addHash = t1 === undefined ? false : t1;
      const offset = t2 === undefined ? 0 : t2;
      const element = document.getElementById(id);
      if (!element) {
        return null;
      }
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - offset - TOP_BAR_HEIGHT,
        behavior: "auto"
      });
      setTimeout(() => element.focus(), 10);
      if (addHash) {
        router.push(`#${id}`);
      }
      return element;
    };
    t0 = {
      scrollToSection
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};